module.exports = __webpack_public_path__ + "img/login_icon.4bba577d.png";